import React, { Fragment, useCallback, useEffect } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { haveAuth, thousandSeparator } from "utils"
import { productUnitLabel, productUnitsSymbol } from "constant"
import classes from "./FoodModalRightSideHeader.module.scss"

const items = ["quantity", "salePrice", "discount", "reduction"]

const FoodModalRightSideHeader = props => {
  const {
    form,
    unit,
    haveAddOns,
    focuedInputName,
    setFocuedInputName
  } = props

  const [t, i18n] = useTranslation()

  const handleKeyPress =
    useCallback((e) => {
      const index =
        items.findIndex(item => item === focuedInputName)

      let newIndex

      switch (e.key) {
        case "ArrowUp": {
          newIndex = index - 2

          break
        }
        case "ArrowRight": {
          newIndex = index - 1

          break
        }
        case "ArrowDown": {
          newIndex = index + 2

          break
        }
        case "ArrowLeft": {
          newIndex = index + 1

          break
        }
        default: newIndex = 4
      }

      if (newIndex < 0) return

      if (newIndex >= items.length) return

      setFocuedInputName(items[newIndex])

    }, [focuedInputName])

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress)

    return () => {
      window.removeEventListener("keydown", handleKeyPress)
    }
  }, [focuedInputName])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      <div className={classes["leftTop"]}>
        <button
          disabled={haveAddOns}
          onClick={() => setFocuedInputName("quantity")}
          className={clsx(
            classes["card"],
            focuedInputName === "quantity" && classes["active"],
          )}
        >
          <span>{t(productUnitLabel[unit])}</span>
          <span className={classes["float"]}>
            {form.quantity} {t(productUnitsSymbol[unit])}
          </span>
        </button>

        <button
          onClick={() => haveAuth(["discount"]) && setFocuedInputName("salePrice")}
          className={clsx(
            classes["card"],
            classes["margin-right"],
            focuedInputName === "salePrice" && classes["active"]
          )}
        >
          <span>{t("قیمت")}</span>
          <span>{thousandSeparator(form.salePrice)}</span>
        </button>
      </div>

      {
        haveAuth(["discount"]) &&
        <div className={clsx(classes["leftTop"], classes["margin-top"])}>
          <button
            onClick={() => setFocuedInputName("discount")}
            className={clsx(
              classes["card"],
              focuedInputName === "discount" && classes["active"]
            )}
          >
            <span>{t("تخفیف")}</span>
            <span className={classes["float"]}>
              {form.discount}%
            </span>
          </button>

          <button
            onClick={() => setFocuedInputName("reduction")}
            className={clsx(
              classes["card"],
              classes["margin-right"],
              isLtr && classes["margin-right-ltr"],
              focuedInputName === "reduction" && classes["active"]
            )}
          >
            <span>{t("کسر")}</span>
            <span>
              {thousandSeparator(form.reduction)}
            </span>
          </button>
        </div>
      }
    </Fragment>
  )
}

export default FoodModalRightSideHeader